module.exports = __webpack_public_path__ + "img/panelView_baoSteel_1_3_.2e59d578.png";